import { UPDATE_APP_DATA } from 'constants/action_types'
import { FETCH_GROUPS_SUCCESS } from 'constants/actionTypes/groups'
import { emptyArr } from 'util/arrays'

const reducers = {}

const defaultState = []

const groupReducer = (state, action) => {
  const { groups = emptyArr } = action.payload || action.data
  return [...state, ...groups]
}
reducers[UPDATE_APP_DATA] = groupReducer
reducers[FETCH_GROUPS_SUCCESS] = groupReducer

export default function reducer(state = defaultState, action) {
  // this is here because a long reducer with many ifs is unreadable
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
